import router from '@/router';
import store from '@/store';
import axios from 'axios';
import qs from 'qs';
import apis from './api';
let params_data = null;
axios.defaults.baseURL = '/college';
//创建axios实例
var instance = axios.create({
	timeout: 100000,
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
	},
	transformRequest: [function (data = {}) {
		//在向服务器发送前，修改请求数据
		return data instanceof FormData ? data : qs.stringify(data)
	}],
	withCredentials: true
})
// 添加响应拦截器
instance.interceptors.response.use(function (response) {
	const responseData = response.data;
	if (responseData.code == 0 || responseData.code == 200 || responseData.code == 1) {
		//返回自定义信息
		return Promise.resolve(responseData);
	} else if (responseData.code == -1) {
		if (params_data && params_data.shop_type == 'qycg') {
			router.replace("/" + router.currentRoute.params.route_url + '/' + router.currentRoute.params.act_key + '/qycgindex')
		} else {
			router.replace({
				name: 'qycglogin',
				query: {
					redirect: router.currentRoute.fullPath
				}
			})
		}
	} else {
		return Promise.reject(responseData);
	}
}, function (error) {
	//提示
	// message.error('服务器无响应')
	//响应
	return Promise.reject(error);
});

const fetch = function (axiosInstance, apiMap) {
	let http = {}
	//填充http
	Object.keys(apiMap).forEach(requestMethod => {
		const method = apiMap[requestMethod]
		Object.keys(method).forEach(api => {
			http[api] = data => {
				params_data = data;
				let basejm;
				const {
					route_url = '',
					act_key = ''
				} = router.currentRoute.params;
				let params = '?store_id=1&_version=2.8.9&_platform=pc';
				if (route_url) {
					params += '&pur_key=' + route_url
				}
				if (act_key) {
					params += '&act_key=' + act_key
				}
				if (data && data.shop_type == 'qycg') {
					if (store.state.qycg_user && store.state.qycg_user.access_token) {
						params += '&access_token=' + store.state.qycg_user.access_token;
					}
				} else {
					if (store.state.user) {
						basejm = store.state.user.access_token;
					}
					if (basejm) {
						params += '&access_token=' + basejm;
					}
				}
				return axiosInstance({
					url: method[api] + params,
					method: requestMethod,
					[requestMethod.toUpperCase() === 'POST' ? 'data' : 'params']: data
				})
			}
		})
	})
	return http
}

export default fetch(instance, apis)